// Context provides multi-select handlers. Mostly complemented by SelectContext.
import { createContext, useContext } from 'react';
export const MultiSelectContext = createContext(undefined);
export const useMultiSelectContext = () => {
    const context = useContext(MultiSelectContext);
    if (context === undefined) {
        throw new Error(`useMultiSelectContext must be used within a MultiSelectContextProvider`);
    }
    return context;
};
